let social = {
    button: document.getElementById('share-btn'),
    label: document.getElementById('social-before-focus'),
    links: document.getElementById('social-after-focus'),
    linkItem: document.querySelectorAll('a[target="shared_by_abskill"]'),
    copyItem: document.querySelector('.copy-button'),

    init: function () {
        social.button.addEventListener('click', social.share);
        social.linkItem.forEach(link => link.addEventListener('click', social.openPopup));
        social.copyItem.addEventListener('click', social.copy);
    },

    share: function () {
        social.links.classList.add('active');
        setTimeout(
            () => {
                social.links.classList.remove('active');
                ('active');
            }, 5000
        );
    },

    copy: function() {
        navigator.clipboard.writeText(window.location.href);
        this.classList.add('copied');
    },

    openPopup: function (e) {
        // Fixes dual-screen position                       
        const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX,
            dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        const win = window,
            d = document,
            el = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            width = win.innerWidth || el.clientWidth || g.clientWidth,
            height = win.innerHeight || el.clientHeight || g.clientHeight;

        const w = 560,
            h = 500,
            left = ((width / 2) - (w / 2)) + dualScreenLeft,
            top = ((height / 2) - (h / 2)) + dualScreenTop;

        const url = this.getAttribute("href"),
            title = this.getAttribute("target");

        if (width > 767) {
            e.preventDefault();
            window.open(url, title, 'toolbar=yes,scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        }
    }

};

document.addEventListener('DOMContentLoaded', social.init);